import React from "react";

const MarkSheetFormatFive = ({ marksheet }) => {
  const { report_info, done_subjects, marks_collection } = marksheet || {};
  const { format_id, title } = report_info || {};
  const formatId = Number(format_id);

  const SubjectHeadRow = ({ item }) => (
    <>
      {item?.done_papers?.map((paper, key) => (
        <td key={key}>{paper.paper_code}</td>
      ))}
      <td>{formatId === 2 ? "Id" : "GD"}</td>
    </>
  );

  const StudentMarksRow = ({ student, studentIndex }) => {
    const studentId = student.id;
    const studentMarks = marks_collection?.[studentId] || {};
    const studentSubjects = marks_collection?.[studentId] || {};
    const ordinaryGrade = studentMarks?.ordinary_grade || {};

    return (
      <tr key={studentId}>
        <td>{studentIndex + 1}</td>
        <td>{student.full_name}</td>

        {done_subjects?.map((subject, key) => {
          const subjectId = subject.subject_info.subject_id;
          const subjectData = studentSubjects?.[subjectId] || {};
          const total_mark = subjectData.total_mark || {};
          const grade = subjectData.advanced_grade || {};

          return (
            <React.Fragment key={key}>
              {subject.done_papers?.map((paper, i) => (
                <td key={i} style={{ textAlign: "center" }}>
                  {total_mark[paper.paper_id] ?? ""}
                </td>
              ))}
              <td
                style={
                  grade?.[subjectId]
                    ? {
                        backgroundColor: "#000000",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        textAlign: "center",
                      }
                    : { textAlign: "center" }
                }
              >
                {grade?.[subjectId]?.grade ?? ""}
              </td>
            </React.Fragment>
          );
        })}

        <td style={{ textAlign: "center", fontWeight: "bold" }}>
          {ordinaryGrade?.aggregates}
        </td>
        <td style={{ textAlign: "center", fontWeight: "bold" }}>
          {ordinaryGrade?.division}
        </td>
      </tr>
    );
  };

  if (!Array.isArray(marks_collection?.student_info)) return null;

  return (
    <table
      width="100%"
      border="1"
      className="Reports"
      style={{ fontSize: "12px" }}
      cellSpacing="0"
      cellPadding="0"
    >
      <caption>{title}</caption>
      <thead>
        <tr>
          <th>NO</th>
          <th>NAMES</th>
          {done_subjects?.map((subject, key) => (
            <th
              key={key}
              colSpan={(subject.total_papers || 0) + 1}
              style={{ textAlign: "center" }}
            >
              {subject.subject_info?.abbreviation}
            </th>
          ))}
          <th style={{ textAlign: "center" }}>AGG</th>
          <th style={{ textAlign: "center" }}>DIV</th>
        </tr>
      </thead>
      <tbody>
        <tr
          style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          {done_subjects?.map((subject, key) => (
            <SubjectHeadRow key={key} item={subject} />
          ))}
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>

        {marks_collection.student_info.map((student, index) => (
          <StudentMarksRow key={student.id} student={student} studentIndex={index} />
        ))}
      </tbody>
    </table>
  );
};

export default MarkSheetFormatFive;
